<template>
  <div class="text-step">
    <el-card class="upload-card" shadow="never">
      <template #header>
        <div class="card-header">
          <span>上传小说原文</span>
          <el-button type="primary" @click="saveText" :loading="saving">
            <el-icon><Check /></el-icon>
            保存
          </el-button>
        </div>
      </template>

      <el-tabs v-model="uploadMode">
        <el-tab-pane label="直接输入" name="input">
          <el-input
            v-model="storyText"
            type="textarea"
            :rows="15"
            placeholder="请在此粘贴小说原文..."
            maxlength="50000"
            show-word-limit
          />
        </el-tab-pane>
        
        <el-tab-pane label="文件上传" name="file">
          <el-upload
            class="upload-area"
            drag
            action="#"
            :auto-upload="false"
            :on-change="handleFileChange"
            accept=".txt,.doc,.docx"
          >
            <el-icon class="el-icon--upload"><upload-filled /></el-icon>
            <div class="el-upload__text">
              拖拽文件到此处或 <em>点击上传</em>
            </div>
            <template #tip>
              <div class="el-upload__tip">
                支持 .txt, .doc, .docx 格式，文件大小不超过 10MB
              </div>
            </template>
          </el-upload>
        </el-tab-pane>
      </el-tabs>
    </el-card>

    <el-card class="info-card" shadow="never">
      <template #header>
        <span>提示</span>
      </template>
      <ul class="tips-list">
        <li>支持上传 .txt、.doc、.docx 格式的文本文件</li>
        <li>建议小说长度在 1000-50000 字之间</li>
        <li>文本内容将用于后续的设定提取和剧本拆解</li>
        <li>上传后可以随时修改和重新上传</li>
      </ul>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { useProjectStore } from '../../stores/project'

const props = defineProps({
  projectId: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['step-complete', 'step-save'])

const projectStore = useProjectStore()
const uploadMode = ref('input')
const storyText = ref('')
const saving = ref(false)

// 加载已有文本
onMounted(async () => {
  if (projectStore.project?.original_text) {
    storyText.value = projectStore.project.original_text
  }
})

// 处理文件上传
const handleFileChange = (file) => {
  const reader = new FileReader()
  reader.onload = (e) => {
    storyText.value = e.target.result
    ElMessage.success('文件读取成功')
  }
  reader.readAsText(file.raw)
}

// 保存文本
const saveText = async () => {
  if (!storyText.value.trim()) {
    ElMessage.warning('请输入或上传小说原文')
    return
  }

  saving.value = true
  try {
    await projectStore.uploadText(storyText.value)
    ElMessage.success('保存成功')
    emit('step-save')
    emit('step-complete')
  } catch (error) {
    console.error('Failed to save text:', error)
    ElMessage.error('保存失败')
  } finally {
    saving.value = false
  }
}
</script>

<style scoped lang="scss">
.text-step {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-card {
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.upload-area {
  :deep(.el-upload) {
    width: 100%;
  }
  
  :deep(.el-upload-dragger) {
    width: 100%;
    height: 200px;
  }
}

.tips-list {
  margin: 0;
  padding-left: 20px;
  
  li {
    margin-bottom: 8px;
    color: #606266;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
